import React from 'react';
import { PostAdd, FeaturedPlayList, Group, GpsFixed, Description, Map, TimelineOutlined } from '@material-ui/icons';
import IntlMessages from '../../../utils/IntlMessages';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { getUserPermissions } from '@jumbo/utils/commonHelper';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import BookmarksIcon from '@material-ui/icons/Bookmarks';

const permissions = getUserPermissions();

const loadboardMenuItem = [
  // permissions &&
  // Object.keys(permissions).length &&
  // ((permissions.hasOwnProperty('loads') &&
  //   Object.keys(permissions.loads).length &&
  //   permissions.loads.hasOwnProperty('loadboard')) ||
  //   permissions.all)
  //   ? {
  //       name: <IntlMessages id={'sidebar.loads.loadboard'} />,
  //       icon: <FeaturedPlayList />,
  //       type: 'item',
  //       link: '/loads/loadboard',
  //     }
  //   : {},

  // permissions &&
  // Object.keys(permissions).length &&
  // ((permissions.hasOwnProperty('loads') &&
  //   Object.keys(permissions.loads).length &&
  //   permissions.loads.hasOwnProperty('user_interests')) ||
  //   permissions.all)
  //   ? {
  //       name: <IntlMessages id={'sidebar.loads.userinterests'} />,
  //       icon: <Description />,
  //       type: 'item',
  //       link: '/loads/user-interests',
  //     }
  //   : {},

  // permissions &&
  // Object.keys(permissions).length &&
  // ((permissions.hasOwnProperty('loads') &&
  //   Object.keys(permissions.loads).length &&
  //   permissions.loads.hasOwnProperty('trip_schedular')) ||
  //   permissions.all)
  //   ? {
  //       name: <IntlMessages id={'sidebar.loads.tripschedular'} />,
  //       icon: <ScheduleIcon />,
  //       type: 'item',
  //       link: '/loads/trip-schedular',
  //     }
  //   : {},

  // permissions &&
  // Object.keys(permissions).length &&
  // ((permissions.hasOwnProperty('loads') &&
  //   Object.keys(permissions.loads).length &&
  //   permissions.loads.hasOwnProperty('documents')) ||
  //   permissions.all)
  //   ? {
  //       name: <IntlMessages id={'sidebar.loads.documents'} />,
  //       icon: <Description />,
  //       type: 'item',
  //       link: '/loads/documents',
  //     }
  //   : {},

  // {
  //   name: <IntlMessages id={'sidebar.loads.tripschedular'} />,
  //   icon: <ScheduleIcon />,
  //   type: 'item',
  //   link: '/loads/trip-schedular',
  // },
  // {
  //   name: <IntlMessages id={'sidebar.loads.tripinterests'} />,
  //   icon: <Description />,
  //   type: 'item',
  //   link: '/loads/trips',
  //   onClick: () => {
  //     localStorage.setItem('trip.tab', 1);
  //   },
  // },
  // {
  //   name: <IntlMessages id={'sidebar.loads.workbook'} />,
  //   icon: <BookmarksIcon />,
  //   type: 'item',
  //   link: '/loads/workbook',
  // },
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('loads') &&
    Object.keys(permissions.loads).length &&
    permissions.loads.hasOwnProperty('lanes')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.loads.lanes'} />,
        icon: <Description />,
        type: 'item',
        link: '/loads/lanes',
      }
    : {},
];

const laneInterests = [

  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('lanes') &&
    Object.keys(permissions.lanes).length &&
    permissions.lanes.hasOwnProperty('user_interests')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.lanes.AllInterests'} />,
        icon: <Description />,
        type: 'item',
        link: '/lanes/interests/all',
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('lanes') &&
    Object.keys(permissions.lanes).length &&
    permissions.lanes.hasOwnProperty('user_interests')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.lanes.NewInterests'} />,
        icon: <Description />,
        type: 'item',
        link: '/lanes/interests/new',
      }
    : {},

permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('lanes') &&
    Object.keys(permissions.lanes).length &&
    permissions.lanes.hasOwnProperty('user_interests')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.lanes.Followup'} />,
        icon: <Description />,
        type: 'item',
        link: '/lanes/interests/follow-up',
      }
    : {},

  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('lanes') &&
    Object.keys(permissions.lanes).length &&
    permissions.lanes.hasOwnProperty('user_interests')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.lanes.InProgress'} />,
        icon: <Description />,
        type: 'item',
        link: '/lanes/interests/in-progress',
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('lanes') &&
    Object.keys(permissions.lanes).length &&
    permissions.lanes.hasOwnProperty('user_interests')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.lanes.FutureProspect'} />,
        icon: <Description />,
        type: 'item',
        link: '/lanes/interests/future-prospect',
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('lanes') &&
    Object.keys(permissions.lanes).length &&
    permissions.lanes.hasOwnProperty('user_interests')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.lanes.Disqualified'} />,
        icon: <Description />,
        type: 'item',
        link: '/lanes/interests/disqualified',
      }
  : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('lanes') &&
    Object.keys(permissions.lanes).length &&
    permissions.lanes.hasOwnProperty('upload_lanes')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.lanes.upload'} />,
        icon: <Description />,
        type: 'item',
        link: '/lanes/upload',
      }
    : {}

];

const customersMenuItem = [
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('customers') &&
    Object.keys(permissions.customers).length &&
    permissions.customers.hasOwnProperty('owner_operator')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.customers.owner_operator'} />,
        icon: <Group />,
        type: 'item',
        link: '/customers/owner_operator',
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('customers') &&
    Object.keys(permissions.customers).length &&
    permissions.customers.hasOwnProperty('driver')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.customers.driver'} />,
        icon: <Group />,
        type: 'item',
        link: '/customers/driver',
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('customers') &&
    Object.keys(permissions.customers).length &&
    permissions.customers.hasOwnProperty('company')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.customers.company'} />,
        icon: <Group />,
        type: 'item',
        link: '/customers/company',
      }
    : {},
  // permissions &&
  // Object.keys(permissions).length &&
  // ((permissions.hasOwnProperty('customers') &&
  //   Object.keys(permissions.customers).length &&
  //   permissions.customers.hasOwnProperty('onboarding')) ||
  //   permissions.all)
  //   ? {
  //       name: <IntlMessages id={'sidebar.customers.onboarding'} />,
  //       icon: <Group />,
  //       type: 'item',
  //       link: '/customers/onboarding',
  //     }
  //   : {},
];

const workbookMenuItem = [
  // permissions &&
  // Object.keys(permissions).length &&
  // ((permissions.hasOwnProperty('workbook') &&
  //   Object.keys(permissions.workbook).length &&
  //   permissions.workbook.hasOwnProperty('requests')) ||
  //   permissions.all)
  //   ? {
  //       name: <IntlMessages id={'sidebar.workbook.requests'} />,
  //       icon: <BookmarkBorderIcon />,
  //       type: 'item',
  //       link: '/workbook/requests',
  //     }
  //   : {},
  // permissions &&
  // Object.keys(permissions).length &&
  // ((permissions.hasOwnProperty('workbook') &&
  //   Object.keys(permissions.loads).length &&
  //   permissions.loads.hasOwnProperty('bookings')) ||
  //   permissions.all)
  //   ? {
  //       name: <IntlMessages id={'sidebar.workbook.bookings'} />,
  //       icon: <BookmarksIcon />,
  //       type: 'item',
  //       link: '/workbook/bookings',
  //     }
  //   : {},
];

const usersMenuItem = [
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('user_management') &&
    Object.keys(permissions.user_management).length &&
    permissions.user_management.hasOwnProperty('users')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.users.admin'} />,
        icon: <Group />,
        type: 'item',
        link: '/users/admin',
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('user_management') &&
    Object.keys(permissions.user_management).length &&
    permissions.user_management.hasOwnProperty('roles')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.users.roles'} />,
        icon: <Group />,
        type: 'item',
        link: '/users/roles',
      }
    : {},
];

const dashboardsMenus = [
  {
    name: <IntlMessages id={'sidebar.dashboard.heatmap'} />,
    icon: <Map />,
    type: 'item',
    link: '/dashboard/heatmap',
  },
  // {
  //   name: <IntlMessages id={'sidebar.dashboard.product'} />,
  //   icon: <TimelineOutlined />,
  //   type: 'item',
  //   link: '/dashboard/product-kpi',
  // },
  // {
  //   name: <IntlMessages id={'sidebar.dashboard.shipper'} />,
  //   icon: <TimelineOutlined />,
  //   type: 'item',
  //   link: '/dashboard/shipper-kpi',
  // },
  // {
  //   name: <IntlMessages id={'sidebar.dashboard.carrier'} />,
  //   icon: <TimelineOutlined />,
  //   type: 'item',
  //   link: '/dashboard/carrier-kpi',
  // },
];

const trackingMenuItem = [
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('loads') &&
    Object.keys(permissions.loads).length &&
    permissions.loads.hasOwnProperty('loads_tracking')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.loads.tracking'} />,
        icon: <GpsFixed />,
        type: 'item',
        link: '/loads/tracking',
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('loads') &&
    Object.keys(permissions.loads).length &&
    permissions.loads.hasOwnProperty('loads_tracking')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.loads.trackingdashboard'} />,
        icon: <TimelineOutlined />,
        type: 'item',
        link: '/dashboard/tracking-kpi',
      }
    : {},
];

const dashboardMenuItem =
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('dashboard') &&
    Object.keys(permissions.dashboard).length &&
    permissions.dashboard.hasOwnProperty('heatmap')) ||
    permissions.all)
    ? dashboardsMenus
    : {};

const utilsMenuItem = [
  {
    name: <IntlMessages id={'sidebar.utils.sms'} />,
    icon: <Map />,
    type: 'item',
    link: '/utils/sms',
  }
]

const fleetManagementMenuItem = [
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('fleet_management') &&
    Object.keys(permissions.onboarding).length &&
    permissions.onboarding.hasOwnProperty('tb_owneroperators')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.fleet_management.tbowneroperators'} />,
        icon: <Group />,
        type: 'item',
        link: '/fleet-management/tb-owner-operators',
      }
    : {},
];

const carrierMenuItem = [
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('carriers') &&
    Object.keys(permissions.carriers).length &&
    permissions.loads.hasOwnProperty('carriers.carrier_network')) ||
    permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.carriernetworkintelligence'} />,
        icon: <Group />,
        type: 'item',
        link: '/carriers/carrier-network-intelligence',
      }
    : {},
];

const sectionList = [
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('dashboard') && Object.keys(permissions.dashboard).length) || permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.main'} />,
        type: 'section',
        children: [
          {
            name: <IntlMessages id={'pages.samplePage'} />,
            type: 'item',
            icon: <PostAdd />,
            link: '/sample-page',
          },
        ],
        name: <IntlMessages id={'sidebar.kpi_dashboards'} />,
        type: 'section',
        children: dashboardMenuItem,
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('loads') && Object.keys(permissions.loads).length) || permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.main'} />,
        type: 'collapse',
        children: [
          {
            name: <IntlMessages id={'pages.samplePage'} />,
            type: 'item',
            icon: <PostAdd />,
            link: '/sample-page',
          },
        ],
        name: <IntlMessages id={'sidebar.loads'} />,
        type: 'section',
        children: loadboardMenuItem,
      }
    : {},
  // permissions &&
  // Object.keys(permissions).length &&
  // ((permissions.hasOwnProperty('workbook') && Object.keys(permissions.workbook).length) || permissions.all)
  //   ? {
  //       name: <IntlMessages id={'sidebar.main'} />,
  //       type: 'collapse',
  //       children: [
  //         {
  //           name: <IntlMessages id={'pages.samplePage'} />,
  //           type: 'item',
  //           icon: <PostAdd />,
  //           link: '/sample-page',
  //         },
  //       ],
  //       name: <IntlMessages id={'sidebar.workbook'} />,
  //       type: 'section',
  //       children: workbookMenuItem,
  //     }
  //   : {},
  // permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('loads') && Object.keys(permissions.loads).length) || permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.main'} />,
        type: 'collapse',
        children: [
          {
            name: <IntlMessages id={'pages.samplePage'} />,
            type: 'item',
            icon: <PostAdd />,
            link: '/sample-page',
          },
        ],
        name: <IntlMessages id={'sidebar.stayontrack'} />,
        type: 'section',
        children: trackingMenuItem,
      }
    : {},
  
  permissions && 
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('lanes') && Object.keys(permissions.lanes).length) || permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.main'} />,
        type: 'collapse',
        children: [
          {
            name: <IntlMessages id={'pages.samplePage'} />,
            type: 'item',
            icon: <PostAdd />,
            link: '/sample-page',
          },
        ],
        name: <IntlMessages id={'sidebar.lanes'} />,
        type: 'section',
        children: laneInterests,
      }
    : {},
  permissions && 
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('utils') && Object.keys(permissions.utils).length) || permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.utils'} />,
        type: 'section',
        children: utilsMenuItem,
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('carriers') && Object.keys(permissions.carriers).length) || permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.main'} />,
        type: 'collapse',
        children: [
          {
            name: <IntlMessages id={'pages.samplePage'} />,
            type: 'item',
            icon: <PostAdd />,
            link: '/sample-page',
          },
        ],
        name: <IntlMessages id={'sidebar.carriers'} />,
        type: 'section',
        children: carrierMenuItem,
      }
    : {},
  // permissions &&
  // Object.keys(permissions).length &&
  // ((permissions.hasOwnProperty('onboarding') && Object.keys(permissions.onboarding).length) || permissions.all)
  //   ? {
  //       name: <IntlMessages id={'sidebar.main'} />,
  //       type: 'collapse',
  //       children: [
  //         {
  //           name: <IntlMessages id={'pages.samplePage'} />,
  //           type: 'item',
  //           icon: <PostAdd />,
  //           link: '/sample-page',
  //         },
  //       ],
  //       name: <IntlMessages id={'sidebar.fleetManagement'} />,
  //       type: 'section',
  //       children: fleetManagementMenuItem,
  //     }
  //   : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('customers') && Object.keys(permissions.customers).length) || permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.main'} />,
        type: 'section',
        children: [
          {
            name: <IntlMessages id={'pages.samplePage'} />,
            type: 'item',
            icon: <PostAdd />,
            link: '/sample-page',
          },
        ],
        name: <IntlMessages id={'sidebar.customers'} />,
        type: 'section',
        children: customersMenuItem,
      }
    : {},
  permissions &&
  Object.keys(permissions).length &&
  ((permissions.hasOwnProperty('user_management') && Object.keys(permissions.user_management).length) || permissions.all)
    ? {
        name: <IntlMessages id={'sidebar.main'} />,
        type: 'section',
        children: [
          {
            name: <IntlMessages id={'pages.samplePage'} />,
            type: 'item',
            icon: <PostAdd />,
            link: '/sample-page',
          },
        ],
        name: <IntlMessages id={'sidebar.users'} />,
        type: 'section',
        children: usersMenuItem,
      }
    : {},
];

export const sidebarNavs = sectionList;

export const horizontalDefaultNavs = [
  {
    name: <IntlMessages id={'sidebar.main'} />,
    type: 'collapse',
    children: [
      {
        name: <IntlMessages id={'pages.samplePage'} />,
        type: 'item',
        icon: <PostAdd />,
        link: '/sample-page',
      },
    ],
    name: <IntlMessages id={'sidebar.loads'} />,
    type: 'section',
    children: loadboardMenuItem,
  },
  {
    name: <IntlMessages id={'sidebar.main'} />,
    type: 'section',
    children: [
      {
        name: <IntlMessages id={'pages.samplePage'} />,
        type: 'item',
        icon: <PostAdd />,
        link: '/sample-page',
      },
    ],
    name: <IntlMessages id={'sidebar.users'} />,
    type: 'section',
    children: usersMenuItem,
  },
  {
    name: <IntlMessages id={'sidebar.main'} />,
    type: 'section',
    children: [
      {
        name: <IntlMessages id={'pages.samplePage'} />,
        type: 'item',
        icon: <PostAdd />,
        link: '/sample-page',
      },
    ],
    name: <IntlMessages id={'sidebar.kpi_dashboards'} />,
    type: 'section',
    children: dashboardMenuItem,
  },
];

export const minimalHorizontalMenus = sectionList;
